/**
 * Consecutive-failure counter for the background build-version poll
 * (`useAppVersionCheck` -> `/version.json`, every 5 minutes per tab).
 *
 * Sentry OFFICEHUB-CLIENT-68: 5 events / 3 users in 14 days, each ONE Firebase
 * Hosting 500 after ~28s, with the polls before and after it succeeding — and
 * every one paged the dev Chat as a new error. One failed poll is a hosting
 * blip; a broken or missing build stamp fails EVERY poll. So a failure is
 * counted, a successful poll resets the count, and the streak is reported once,
 * when it reaches the threshold (about 15 minutes of polls).
 *
 * Per browser tab, in memory — like transportFailureCounter. A stamp broken
 * for everyone trips it in every open tab, so it still shows as many users.
 */

export const VERSION_POLL_STREAK_THRESHOLD = 3;

let consecutiveFailures = 0;

/** Count one failed poll. `report` is true exactly once per streak. */
export function recordVersionPollFailure(): { consecutive: number; report: boolean } {
  consecutiveFailures += 1;
  return {
    consecutive: consecutiveFailures,
    report: consecutiveFailures === VERSION_POLL_STREAK_THRESHOLD,
  };
}

/** A poll succeeded: the streak is over. */
export function recordVersionPollSuccess(): void {
  consecutiveFailures = 0;
}
